<template>
  <div class="card" style="max-width: 700px; margin: auto">
    <div v-if="$store.getters.getCurrentUser" class="card-content">
      <p class="title">
        {{ $t("logIn") }}
      </p>

      <b-button
        v-for="org in organizations"
        :key="org.id"
        size="is-large"
        icon-left="domain"
        style="width: 100%; justify-content: left; padding-left: 1.1em; margin-bottom: 0.5em"
        @click="goToContentPage(org.id)"
      >
        {{ org.legalName }}
      </b-button>

      <b-button
        v-if="$store.getters.getPermissions.includes('platform')"
        size="is-large"
        icon-left="account-outline"
        style="width: 100%; justify-content: left; padding_left: 1.1em; margin-bottom: 0.5em"
        tag="router-link"
        :to="{ name: 'PlatformDashboard' }"
      >
        {{ $t("platformDashboard") }}
      </b-button>

      <b-button
        size="is-large"
        icon-left="plus"
        style="width: 100%; justify-content: left; padding-left: 1.1em; margin-bottom: 0.5em"
        tag="router-link"
        :to="{ name: 'Register', params: { target: 'organization' } }"
      >
        {{ $t("createOrganization") }}
      </b-button>
    </div>
    <div v-else class="card-content">
      <p class="title">
        {{ $t("logInTitle") }}
      </p>
      <form ref="form">
        <b-field :label="$t('email')" :type="emailError ? 'is-danger' : ''" :message="emailError">
          <b-input v-model="email" type="email" required @keyup.native.enter="logIn" />
        </b-field>
        <b-field :label="$t('password')" :type="passwordError ? 'is-danger' : ''" :message="passwordError">
          <b-input v-model="password" type="password" required @keyup.native.enter="logIn" />
        </b-field>
        <b-field class="mt-4">
          <b-button type="is-primary" :disabled="!valid" :loading="isLoading" @click="logIn">
            {{ $t("logIn") }}
          </b-button>
          <slot />
        </b-field>
        <b-field>
          <a href="" size="is-small" @click.prevent="forgotPassword">
            {{ $t("forgotPassword") }}
          </a>
        </b-field>
      </form>
    </div>
    <b-modal
      :active.sync="resetPasswordModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <PasswordResetModal />
    </b-modal>
  </div>
</template>

<script>
import { db, auth } from "@/firebase";
import PasswordResetModal from "@/components/PasswordResetModal";
import { mapState } from "vuex";

export default {
  name: "LoginCard",
  components: {
    PasswordResetModal,
  },
  data() {
    return {
      email: "",
      emailError: "",
      password: "",
      passwordError: "",
      organizations: [],
      valid: true,
      isLoading: false,
      resetPasswordModalActive: false,
      trialSubscriptionDetails: null,
    };
  },
  computed: {
    ...mapState({
      subscriptionPlan: (state) => state.subscriptionPlan,
      subscriptionDetails: (state) => state.subscriptionDetails,
      subscriptionTrial: (state) => state.subscriptionTrial,
      routeTosubsPage: (state) => state.routeTosubsPage,
    }),
  },
  watch: {
    email() {
      this.emailError = "";
      this.valid = this.$refs.form.checkValidity();
    },
    password() {
      this.passwordError = "";
      this.valid = this.$refs.form.checkValidity();
    },
  },
  async mounted() {
    document.title = this.$t("logInTitle");

    // let orgDocSnapshot = await db
    //   .collection("organizations")
    //   .doc(this.organizationId)
    //   .get();
    // this.trialSubscriptionDetails = orgDocSnapshot.data().trialSubscription;
  },
  beforeDestroy() {
    document.title = "Qonda";
  },
  created() {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        let adminsSnap = await db.collectionGroup("admins").where("userId", "==", user.uid).get();
        this.organizations = [];
        for (let i in adminsSnap.docs) {
          let orgSnap = await adminsSnap.docs[i].ref.parent.parent.get();
          let obj = orgSnap.data();
          obj.id = orgSnap.id;
          this.organizations.push(obj);
        }
      } else {
        this.organizations = [];
      }
    });
  },
  methods: {
    forgotPassword() {
      this.resetPasswordModalActive = true;
    },
    logIn() {
      this.isLoading = true;
      this.$store
        .dispatch("logInUser", { email: this.email, password: this.password })
        .then(async () => {})
        .catch((err) => {
          let translatedErr = this.$t(err.code);
          if (err.code === "auth/wrong-password") {
            this.passwordError = translatedErr;
          } else if (err.code === "auth/user-not-found") {
            this.emailError = translatedErr;
          } else {
            this.$buefy.toast.open({
              type: "is-danger",
              message: translatedErr,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // Routes to dashborad or subs page
    async goToContentPage(organizationId) {
      //Setting organizationId to session storage
      sessionStorage.organizationId = organizationId;

      // Check what to load, dashboard or subscription order page
      if (this.routeTosubsPage && !this.subscriptionTrial) {
        this.$router.push({
          name: "Subscription",
          query: {
            type: this.subscriptionDetails.type,
            plan: this.subscriptionDetails.plan,
            amount: this.subscriptionDetails.amount,
            maxUser: this.subscriptionDetails.maxUser,
            maxLang: this.subscriptionDetails.maxLang,
            billInterval: this.subscriptionDetails.billInterval,
            currency: this.subscriptionDetails.currency,
          },
          params: { organizationId: organizationId },
        });
      } else if (this.routeTosubsPage && this.subscriptionTrial) {
        this.$router.push({
          name: "Subscription",
          query: {
            type: "trial",
          },
          params: { organizationId: organizationId },
        });
      } else {
        this.$router.push({
          name: "Dashboard",
          params: { organizationId: organizationId },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
